import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, tap, map} from "rxjs/operators";
 
import {StreamProject, StreamAccessKey, StreamChat, RestreamItem} from "../interfaces";
import {StatService} from "./stat.service";
@Injectable({providedIn: 'root'})
export class SaleService {

  constructor(private http: HttpClient){
  }
 

  // Buying happens inside the modal: these return the bank's invoice URL, which
  // the modal frames. The buyer never leaves the page they are on, and there is
  // no second tab left behind for them to close.
  //
  // A refusal comes back with a `message` written for the buyer - "the author has
  // not connected payments yet" rather than a redirect to /page-not-found, which
  // reads as if the stream itself were gone.

  createSaleOrder(streamPublicIdentity:string, email:string, phone:string, sockKey:string){
    return this.http.post<any>(`/api/income/sale/create`,
      {stream: streamPublicIdentity, email, phone, sockKey})
  }

  createPlaylistOrder(playlistId:string, email:string, phone:string, sockKey:string){
    return this.http.post<any>(`/api/income/playlist/create`,
      {playlist: playlistId, email, phone, sockKey})
  }

  createDonateOrder(streamPublicIdentity:string, amount:number, sockKey:string){
    return this.http.post<any>(`/api/income/donate/create`,
      {stream: streamPublicIdentity, amount, sockKey})
  }

  // The socket says "paid" the moment the webhook lands. This is what the modal
  // falls back to when the socket was dropped - by a proxy, a locked phone, a
  // sleeping laptop - so a buyer who paid always ends up with their code.
  // The sockKey proves the caller is the buyer who started this order: the id
  // alone is public enough to guess, and the answer contains an access code.
  getOrderStatus(orderId:string, sockKey:string){
    let params = new HttpParams()
    if(sockKey){ params = params.set('sockKey', sockKey) }
    return this.http.get<any>(`/api/income/order_status/${orderId}`, {params})
  }


  // The author's own selling state: whether payments can reach them, and at what
  // commission. Answered by the same gate an invoice goes through.
  getSellerStatus(){
    return this.http.get<any>(`/api/income/seller_status`)
  }

  // What the author sold, what the service took and what the bank sent on. Not a
  // balance - the platform never holds this money.
  getSalesSummary(){
    return this.http.get<any>(`/api/income/sales_summary`)
  }

  // One row per paid order: date, what was sold, withheld, credited. The same
  // filter drives the totals returned alongside the rows.
  getPayouts(opts:any = {}){
    let params = new HttpParams()
    if(opts.period){ params = params.set('period', opts.period) }
    if(opts.kind){ params = params.set('kind', opts.kind) }
    if(opts.q){ params = params.set('q', opts.q) }
    if(opts.content){ params = params.set('content', opts.content) }
    if(opts.page){ params = params.set('page', String(opts.page)) }
    return this.http.get<any>(`/api/income/payouts`, {params})
  }

  // The same money grouped by what was sold.
  getPayoutsByContent(period:string){
    let params = new HttpParams()
    if(period){ params = params.set('period', period) }
    return this.http.get<any>(`/api/income/payouts_by_content`, {params})
  }

  requestSellerOnboarding(data:any){
    return this.http.post<any>(`/api/income/seller_request`, data)
  }


}
